import React from 'react';
import './ChatHistoryTable.css';
import { useGetChatHistoryQuery } from '../../../service/apiSlices/dashboard';
import { ChatHistoryItem } from '../../../utilities/types/common';
import { transformChatHistoryData } from '../../../utilities/utils';
import { RootState } from '../../../service/store';
import { useSelector } from 'react-redux';

interface ChatHistoryTableProps {
    visible: boolean;
    onClose: () => void;
    chatHistory: ChatHistoryItem[]; // This is optional prop. If you are get data from the main component you can use this.
}

const ChatHistoryTable: React.FC<ChatHistoryTableProps> = ({ visible, onClose, chatHistory }) => {
    const isModalsOpens = useSelector((state: RootState) => state?.static.dashboardModalsOpens);

    const { data: chatHistoryData, isLoading, error } = useGetChatHistoryQuery("", { skip: !visible });
    const transformedData: ChatHistoryItem[] = React.useMemo(() => {
        if (!chatHistoryData || !Array.isArray(chatHistoryData?.data)) {
            return [];
        }
        const transformed = transformChatHistoryData(chatHistoryData?.data);
        return transformed;
    }, [chatHistoryData]);
    const handleTableWheel = (e: any) => {
        e.stopPropagation();
    };

    return (
        <div className={isModalsOpens ? 'chat-history-table d-none' : 'chat-history-table'} onWheel={handleTableWheel}>
            <div className='table-responsive'>
                <table className='table table-bordered table-transparent w-100' cellSpacing={0} cellPadding={0}>
                    {transformedData.length > 0 && (
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th style={{ width: '15%' }}>Email</th>
                                <th style={{ width: '10%' }}>Topic name</th>
                                <th style={{ width: '15%' }}>Question</th>
                                <th style={{ width: '30%' }}>Answer</th>
                                <th style={{ width: '15%' }}>Model name</th>
                                <th style={{ width: '15%' }}>Created on</th>
                            </tr>
                        </thead>
                    )}
                    <tbody className='table-responsive-body'>
                        {isLoading ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : error ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    Error loading chat history: {error.toString()}
                                </td>
                            </tr>
                        ) : transformedData.length > 0 ? (
                            transformedData.map((item: any) => (
                                <tr key={item.sno}>
                                    <td className="text-center px-3">{item.sno}</td>
                                    <td>{item.email}</td>
                                    <td>{item.topicName}</td>
                                    <td>{item.question}</td>
                                    <td>
                                        <div className="answer">{item?.answer}</div>
                                    </td>
                                    <td>{item.modelName}</td>
                                    <td>{new Date(item.createdOn).toLocaleString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr className='empty-table-row'>
                                <td colSpan={7} className="text-center">
                                    No chat history available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ChatHistoryTable;